import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-lg font-medium mt-3 md:mt-5 mb-5 md:mb-6" }

import ApiConnection from '~src/admin/components/settings/ApiConnection.vue';
import Container from '../components/layout/Container.vue';
import PageHeading from '../components/layout/PageHeading.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'MissingApiKey',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Container, null, {
    default: _withCtx(() => [
      _createVNode(PageHeading, {
        heading: _ctx.$gettext('Missing API Key'),
        "show-posts-limit": false
      }, null, 8, ["heading"]),
      _createElementVNode("h3", _hoisted_1, _toDisplayString(_ctx.$gettext('It looks like you don\'t have an API key. Check your connection and reset the API key if needed.')), 1),
      _createVNode(ApiConnection)
    ]),
    _: 1
  }))
}
}

})